const statesWithEinAndSN = ["Oregon"];

export default statesWithEinAndSN;
